export const ADD_PRIORITY_SCHEME_MODAL_SOURCE_NAME = 'addPrioritySchemeModal';
export const EDIT_PRIORITY_SCHEME_MODAL_SOURCE_NAME = 'editPrioritySchemeModal';
export const PRIORITY_SCHEME_CONFIGURATION_SOURCE_NAME = 'prioritySchemeConfiguration';

export const addPrioritySchemeButtonUIEvent = {
	action: 'clicked',
	actionSubject: 'button',
	actionSubjectId: 'addPrioritySchemeButtonClicked',
};

export const addPrioritySchemeTrackEvent = {
	action: 'created',
	actionSubject: 'priorityScheme',
	actionSubjectId: 'addPriorityScheme',
};

export const actionsDropdownMenuUIEvent = {
	action: 'toggled',
	actionSubject: 'dropdownMenu',
	actionSubjectId: 'actionsDropdownMenuToggled',
};

export const editPrioritySchemeDropdownItemUIEvent = {
	action: 'clicked',
	actionSubject: 'dropdownItem',
	actionSubjectId: 'editPrioritySchemeDropdownItemClicked',
};

export const editPrioritySchemeTrackEvent = {
	action: 'updated',
	actionSubject: 'priorityScheme',
	actionSubjectId: 'editPriorityScheme',
};

export const deletePrioritySchemeDropdownItemUIEvent = {
	action: 'clicked',
	actionSubject: 'dropdownItem',
	actionSubjectId: 'deletePrioritySchemeDropdownItemClicked',
};

export const deletePrioritySchemeTrackEvent = {
	action: 'deleted',
	actionSubject: 'priorityScheme',
	actionSubjectId: 'deletePriorityScheme',
};

export const inProductHelpButtonForPrioritySchemesUIEvent = {
	action: 'clicked',
	actionSubject: 'button',
	actionSubjectId: 'helpPrioritySchemeClicked',
};

// Data Test IDs
export const ADD_PRIORITY_SCHEME_BUTTON_SELECTOR =
	'admin-pages-priority-schemes.ui.priority-schemes-header.add-priority-scheme';
export const ADD_PRIORITY_SCHEME_BUTTON_LIMIT_EXCEEDED_TOOLTIP_SELECTOR =
	'admin-pages-priority-schemes.ui.priority-schemes-header.tooltip';
export const DELETE_MODAL_SELECTOR =
	'admin-pages-priority-schemes.ui.delete-priority-scheme-modal.delete-modal-view.modal';
export const DELETE_MODAL_SPINNER_SELECTOR =
	'admin-pages-priority-schemes.ui.delete-priority-scheme-modal.delete-modal-view.delete-modal';
export const DELETE_MODAL_SUBMIT_BUTTON_SELECTOR =
	'admin-pages-priority-schemes.ui.delete-priority-scheme-modal.delete-modal-view.button';
export const INVALID_DELETE_MODAL_SELECTOR =
	'admin-pages-priority-schemes.ui.delete-priority-scheme-modal.invalid-delete-modal-view.modal';
export const INVALID_DELETE_MODAL_CONFIRM_BUTTON_SELECTOR =
	'admin-pages-priority-schemes.ui.delete-priority-scheme-modal.invalid-delete-modal-view.button';
export const LEARN_MORE_LINK_SELECTOR =
	'admin-pages-priority-schemes.ui.priority-schemes-header.header-description.p';
export const NEXT_PAGE_PAGINATOR_SELECTOR =
	'admin-pages-priority-schemes.ui.priority-schemes-table.dynamic-table-stateless--pagination--right-navigator';
export const PAGE_ERROR_STATE_SELECTOR = 'common-components-error-state.empty-state';
export const PRIORITY_PICKER_DROPDOWN_SELECTOR =
	'admin-pages-priority-schemes.common.ui.priority-picker.dropdown-menu--trigger';
export const PRIORITY_PICKER_DROPDOWN_MENU_SELECTOR =
	'admin-pages-priority-schemes.common.ui.priority-picker.dropdown-menu';
export const PRIORITY_PICKER_DROPDOWN_MENU_GROUP_SELECTOR =
	'admin-pages-priority-schemes.common.ui.priority-picker.dropdown-menu--menu-wrapper--menu-group';
export const PRIORITY_SCHEME_MODAL =
	'admin-pages-priority-schemes.ui.priority-scheme-modal.modal-view.modal';
export const PRIORITY_SCHEME_MODAL_DESC_FIELD_VALIDATION_ERROR_SELECTOR =
	'admin-pages-priority-schemes.ui.priority-scheme-modal.priority-scheme-details.name-and-description.description-error-message';
export const PRIORITY_SCHEME_MODAL_NAME_AND_DESCRIPTION_FIELDS_SELECTOR =
	'admin-pages-priority-schemes.ui.priority-scheme-modal.priority-scheme-details.name-and-description.text-field';
export const PRIORITY_SCHEME_MODAL_NAME_FIELD_VALIDATION_ERROR_SELECTOR =
	'admin-pages-priority-schemes.ui.priority-scheme-modal.priority-scheme-details.name-and-description.name-error-message';
export const PRIORITY_SCHEME_MODAL_PRIORITIES_FIELD_VALIDATION_ERROR_SELECTOR =
	'admin-pages-priority-schemes.ui.priority-scheme-modal.priority-scheme-details.priorities.priorities-error-message';
export const PRIORITY_SCHEME_MODAL_PRIORITY_PICKER_DROPDOWN_SELECTOR =
	'admin-pages-priority-schemes.ui.priority-scheme-modal.priority-scheme-details.priorities.priorities-picker--trigger';
export const PRIORITY_SCHEME_MODAL_PRIORITY_PICKER_DROPDOWN_MENU_SELECTOR =
	'admin-pages-priority-schemes.ui.priority-scheme-modal.priority-scheme-details.priorities.priorities-picker';
export const PRIORITY_SCHEME_MODAL_PRIORITY_PICKER_DROPDOWN_MENU_GROUP_SELECTOR =
	'admin-pages-priority-schemes.ui.priority-scheme-modal.priority-scheme-details.priorities.priorities-picker--menu-wrapper--menu-group';
export const PRIORITY_SCHEME_MODAL_SUBMIT_BUTTON_SELECTOR =
	'admin-pages-priority-schemes.ui.priority-scheme-modal.button';
export const PRIORITY_SCHEME_SEARCH_FIELD_SELECTOR = 'Filter by name';
export const PRIORITY_SCHEME_TABLE_EMPTY_SELECTOR =
	'admin-pages-priority-schemes.ui.priority-schemes-table.dynamic-table-stateless--empty-view-container';
export const PRIORITY_SCHEME_TABLE_SELECTOR =
	'admin-pages-priority-schemes.ui.priority-schemes-table.dynamic-table-stateless--table';
export const ACTIONS_CELL_DROPDOWN_SELECTOR =
	'admin-pages-priority-schemes.ui.priority-schemes-table.dropdown-cell.dropdown-menu--trigger';
export const ACTIONS_CELL_DROPDOWN_MENU_GROUP_SELECTOR =
	'admin-pages-priority-schemes.ui.priority-schemes-table.dropdown-cell.dropdown-menu--menu-wrapper--menu-group';
export const ACTIONS_CELL_SELECTOR = 'unlocked-cell-actions';
export const ACTIONS_CELL_LOCKED_SELECTOR = 'locked-cell-actions';
export const NAME_CELL_SELECTOR = 'unlocked-cell-name';
export const PRIORITIES_CELL_SELECTOR = 'unlocked-cell-priorities';
export const PROJECTS_CELL_SELECTOR = 'unlocked-cell-projects';
export const LOCKED_CELL_TOOLTIP_SELECTOR =
	'admin-pages-priority-schemes.common.ui.locked-cell.tooltip';
